import { auth, db } from "./firebase";
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    sendEmailVerification,
    updatePassword,
    signInWithPopup,
    GoogleAuthProvider,
    reauthenticateWithCredential, // Import from firebase/auth
    EmailAuthProvider,             // Import from firebase/auth
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";


export const doCreateUserWithEmailAndPassword = async (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const doSignInWithEmailAndPassword = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const user = result.user;

  console.log("User signed in:", user); // ✅ Now 'user' is used
};

export const doSignOut = () => {
  return auth.signOut();
};

export const doPasswordReset = (email) => {
  return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (newPassword, currentPassword) => {
  const user = auth.currentUser;
  const credential = EmailAuthProvider.credential(user.email, currentPassword);

  return reauthenticateWithCredential(user, credential)
      .then(() => {
          return updatePassword(user, newPassword);
      });
};

export const doSendEmailVerification = () => {
  return sendEmailVerification(auth.currentUser, {
    url: `${window.location.origin}/home`,
  });
};

// New function to handle Stripe subscriptions
export const doCreateStripeSubscription = async (firebaseUser, paymentMethodId, planId) => {
  try {
      // 1. Send Firebase UID and payment method to your server
      const response = await fetch('/create-subscription', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({
              firebaseUid: firebaseUser.uid,
              paymentMethodId: paymentMethodId,
              planId: planId,
          }),
      });

      const data = await response.json();

      if (response.ok) {
          // 2. Store Stripe Customer ID in Firestore
          const usersRef = doc(db, 'users', firebaseUser.uid);
          await setDoc(usersRef, { stripeCustomerId: data.customer.id }, { merge: true });
          return data;
      } else {
          throw new Error(data.error || 'Failed to create subscription');
      }
  } catch (error) {
      console.error('Error creating Stripe subscription:', error);
      throw error; // Re-throw the error to be handled by the caller
  }
};

// New function to get Stripe customer ID from Firestore
export const getStripeCustomerId = async (firebaseUser) => {
  try {
      const usersRef = doc(db, 'users', firebaseUser.uid);
      const userDoc = await getDoc(usersRef);

      if (userDoc.exists()) {
          return userDoc.data().stripeCustomerId || null;
      } else {
          return null;
      }
  } catch (error) {
      console.error('Error getting Stripe customer ID:', error);
      return null;
  }
};
